import { render, staticRenderFns } from "./DepositViewNew.vue?vue&type=template&id=297387af&"
import script from "./DepositViewNew.vue?vue&type=script&lang=js&"
export * from "./DepositViewNew.vue?vue&type=script&lang=js&"
import style0 from "./DepositViewNew.vue?vue&type=style&index=0&id=297387af&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports